import { Collapse, Modal, Tab } from 'bootstrap';
window.bootstrap = { Collapse, Modal, Tab };

import { whenDocumentReady } from '../../../paws/assets/frontend/js/helper/documentready';
import { whenResize } from '../../../paws/assets/frontend/js/helper/resize';
import { wsForm } from '../../../paws/assets/frontend/js/helper/wsform';

whenDocumentReady(initModule);
whenResize(resizeModule);
function initModule() {
    // header height
    SetHeaderHeight();
    SetMegamenuHeight();
    wsForm();
    replaceKeywords();

    document.body.classList.add('paws-loaded');

    if (document.querySelector('.has-megamenu.is-active')) {
        document.querySelector('body').classList.add('expanded-megamenu');
    }
}

function resizeModule() {
    SetHeaderHeight();
    SetMegamenuHeight();
}

function SetHeaderHeight() {
    let headerHeight = 0;
    const header = document.querySelector('header');
    if (header) {
        headerHeight = header.offsetHeight;
    }

    if (headerHeight < 1) {
        setTimeout(function() {SetHeaderHeight()}, 250);
    }

    document.documentElement.style.setProperty('--paws-header-height', headerHeight + 'px');
}

function SetMegamenuHeight() {
    let headerHeight = 0;
    const header = document.querySelector('.has-megamenu.is-active .megamenu');
    if (header) {
        headerHeight = header.offsetHeight;
    }

    if (headerHeight < 1) {
        setTimeout(function() {SetMegamenuHeight()}, 250);
    }

    document.documentElement.style.setProperty('--paws-megamenu-height', headerHeight + 'px');
}

function replaceKeywords() {
    let element = document.querySelector('.main-container');
    if (element) {
        let wordlist = JSON.parse(document.body.dataset.nossWordlist);
        let bodyContent = document.body.innerHTML;
        let finalWordlist = [];
        for (let i = 0; i < wordlist.length; i++) {
            if (bodyContent.includes(wordlist[i])) {
                if (!finalWordlist.includes(wordlist[i])) {
                    finalWordlist.push(wordlist[i]);
                }
            }
        }

        let allElements = GetChildren(element, []);
        ProcessKeywords(allElements, finalWordlist, []);
    }
}

function GetChildren(element, allElements) {
    let children = element.children;
    if (children !== undefined && children.length > 0) {
        for (let i = 0; i < children.length; i++) {
            allElements = GetChildren(children[i], allElements);
        }
    }
    else {
        allElements.push(element);
    }
    return allElements;
}

function ProcessKeywords(allElements, wordlist) {
    let subst = '$1$7$4<i>$2$8$5$11</i>$3$9$6';
    for (let k = 0; k < allElements.length; k++) {
        for (let i = 0; i < wordlist.length; i++) {
            let obj = wordlist[i];
            let rx = new RegExp('([> ])(' + obj + ')([<\\W])|([> ])(' + obj + ')($)|(^)(' + obj + ')([<\\W])|(^)(' + obj + ')($)', 'gms');

            let result = allElements[k].innerHTML.replace(rx, subst);
            if (result !== allElements[k].innerHTML) {
                allElements[k].innerHTML = result;
            }
        }
    }
}